import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PriceList } from '../../models';
import { Company, CompanyEnum } from '../../models/company.model';
import { AccommodationTableComponent } from '../accommodation-table/accommodation-table.component';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { AdultsCourseTableComponent } from '../adults-course-table/adults-course-table.component';
import { ExamPreparationComponent } from '../exam-preparation/exam-preparation.component';
import { GeneralFeeTableComponent } from '../general-fee-table/general-fee-table.component';
import { MoreInfoComponent } from '../more-info/more-info.component';
import { PathwayProgramFeeTableComponent } from '../pathway-program-fee-table/pathway-program-fee-table.component';
import { PathwayProgramTableComponent } from '../pathway-program-table/pathway-program-table.component';
import { SchoolHeaderComponent } from '../school-header/school-header.component';
import { StudentPreparationTableComponent } from '../student-preparation-table/student-preparation-table.component';
import { TransferTableComponent } from '../transfer-table/transfer-table.component';

@Component({
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    SchoolHeaderComponent,
    AccommodationTableComponent,
    TransferTableComponent,
    GeneralFeeTableComponent,
    StudentPreparationTableComponent,
    AdditionalInfoComponent,
    MoreInfoComponent,
    PathwayProgramFeeTableComponent,
    PathwayProgramTableComponent,
    ExamPreparationComponent,
    AdultsCourseTableComponent,
  ],
  selector: 'lx-price-lists-portal-price-lists-data',
  templateUrl: './price-lists-data.component.html',
  styleUrls: ['./price-lists-data.component.scss', './print-price-lists-data.component.scss'],
})
export class PriceListsDataComponent {
  @Input() priceLists: PriceList[] | undefined;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() applicationForms = [];
}
